@let errors = controlErrors$ | async;
<div class="app-control-errors text-danger">
  <span>{{ errors | controlErrorText: defaultControlErrorMessagesOverrides | merge: errorsMessagesOverridesRegistry }}</span>
</div>
